export default [
  // "Mold Custom",
  //   "3D Printing",
  //   "Mold Accessories",
  //   "Product Manufacturing",
  // ];Moulds
  "Mold Custom",
  "Mould Batch Products",
  "Industrial Products",
  "Epidemic Prevention and Control Supplies",
  "Machine List",
];
